"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var Context = /*#__PURE__*/(0, _react.createContext)({
  client: undefined
});

var SecureDocumentsProvider = function SecureDocumentsProvider(_ref) {
  var client = _ref.client,
      children = _ref.children;
  var context = {
    client: client
  };
  return /*#__PURE__*/_react.default.createElement(Context.Provider, {
    value: context
  }, children);
};

SecureDocumentsProvider.Consumer = Context.Consumer;
SecureDocumentsProvider.Context = Context;
SecureDocumentsProvider.Provider = Context.Provider;
var _default = SecureDocumentsProvider;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9jb250ZXh0L1NlY3VyZURvY3VtZW50c1Byb3ZpZGVyL1NlY3VyZURvY3VtZW50c1Byb3ZpZGVyLnRzeCJdLCJuYW1lcyI6WyJDb250ZXh0IiwiY2xpZW50IiwidW5kZWZpbmVkIiwiU2VjdXJlRG9jdW1lbnRzUHJvdmlkZXIiLCJjaGlsZHJlbiIsImNvbnRleHQiLCJDb25zdW1lciIsIlByb3ZpZGVyIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQTs7QUFPQSxJQUFNQSxPQUFPLGdCQUFHLDBCQUFzQztBQUNwREMsRUFBQUEsTUFBTSxFQUFFQztBQUQ0QyxDQUF0QyxDQUFoQjs7QUFJQSxJQUFNQyx1QkFBaUQsR0FBRyxTQUFwREEsdUJBQW9ELE9BQTBCO0FBQUEsTUFBdkJGLE1BQXVCLFFBQXZCQSxNQUF1QjtBQUFBLE1BQWZHLFFBQWUsUUFBZkEsUUFBZTtBQUNsRixNQUFNQyxPQUFPLEdBQUc7QUFBRUosSUFBQUEsTUFBTSxFQUFOQTtBQUFGLEdBQWhCO0FBQ0Esc0JBQU8sNkJBQUMsT0FBRCxDQUFTLFFBQVQ7QUFBa0IsSUFBQSxLQUFLLEVBQUVJO0FBQXpCLEtBQW1DRCxRQUFuQyxDQUFQO0FBQ0QsQ0FIRDs7QUFLQUQsdUJBQXVCLENBQUNHLFFBQXhCLEdBQW1DTixPQUFPLENBQUNNLFFBQTNDO0FBQ0FILHVCQUF1QixDQUFDSCxPQUF4QixHQUFrQ0EsT0FBbEM7QUFDQUcsdUJBQXVCLENBQUNJLFFBQXhCLEdBQW1DUCxPQUFPLENBQUNPLFFBQTNDO2VBRWVKLHVCIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IGNyZWF0ZUNvbnRleHQgfSBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB7XG4gIFNlY3VyZURvY3VtZW50c0NvbnRleHQsXG4gIFNlY3VyZURvY3VtZW50c1Byb3ZpZGVyIGFzIF9TZWN1cmVEb2N1bWVudHNQcm92aWRlcixcbn0gZnJvbSAnLi9TZWN1cmVEb2N1bWVudHNQcm92aWRlci50eXBlcyc7XG5cbmNvbnN0IENvbnRleHQgPSBjcmVhdGVDb250ZXh0PFNlY3VyZURvY3VtZW50c0NvbnRleHQ+KHtcbiAgY2xpZW50OiB1bmRlZmluZWQsXG59KTtcblxuY29uc3QgU2VjdXJlRG9jdW1lbnRzUHJvdmlkZXI6IF9TZWN1cmVEb2N1bWVudHNQcm92aWRlciA9ICh7IGNsaWVudCwgY2hpbGRyZW4gfSkgPT4ge1xuICBjb25zdCBjb250ZXh0ID0geyBjbGllbnQgfTtcbiAgcmV0dXJuIDxDb250ZXh0LlByb3ZpZGVyIHZhbHVlPXtjb250ZXh0fT57Y2hpbGRyZW59PC9Db250ZXh0LlByb3ZpZGVyPjtcbn07XG5cblNlY3VyZURvY3VtZW50c1Byb3ZpZGVyLkNvbnN1bWVyID0gQ29udGV4dC5Db25zdW1lcjtcblNlY3VyZURvY3VtZW50c1Byb3ZpZGVyLkNvbnRleHQgPSBDb250ZXh0O1xuU2VjdXJlRG9jdW1lbnRzUHJvdmlkZXIuUHJvdmlkZXIgPSBDb250ZXh0LlByb3ZpZGVyO1xuXG5leHBvcnQgZGVmYXVsdCBTZWN1cmVEb2N1bWVudHNQcm92aWRlcjtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/securedocuments-sdk-js/dist/react/context/SecureDocumentsProvider/SecureDocumentsProvider.js
// module id = 1792
// module chunks = 0